export default __webpack_public_path__ + "static/photo-bar-2-caeef279c95d0c6255fa2637142c09bf.jpg";